import React, { useEffect, useState, useContext } from "react";
import useMediaQuery from '@mui/material/useMediaQuery';

export const FseaSection = (props) => {
    const [sectionMarginTop, setSectionMarginTop] = useState('');
    const notMobile = useMediaQuery('(min-width:992px)');

    useEffect(() => {
        if (notMobile) {
            let rowPaddingGuest = document.querySelector('.box-fsea').getBoundingClientRect().height;
            setSectionMarginTop((rowPaddingGuest + 80) + "px");
        }
    }, [notMobile]);


    return (
        <>
            {props.cultureCode === "en-us" &&
                <>
                    <div className="header-section text-white text-center py-5" id="FseaSection"><h1 className="h1">FSEA</h1></div>
                    <div className="contaniner-fluid bkg-fsea pt-5" >
                        <div className="container py-5">
                            <div className="row justify-content-center">
                                <div className="col-md-10 text-center intro-fsea" data-aos="zoom-in">
                                    <h2 className="text-uppercase mb-3">A new perspective of shine</h2>
                                    <p className="text-start">F.S.E.A. technology (Ferretti Sustainable Enhanced Architecture), a package of
                                        environmentally friendly cruising solutions:</p>
                                    <div className="row justify-content-center">
                                        <div className="col-md-10">
                                            <ul className="text-start mb-5">
                                                <li><p>fast displacement hull optimised to improve fuel consumption efficiency and
                                                    minimise environmental impact</p></li>
                                                <li><p>a special focus on the use of green materials</p></li>
                                                <li><p>integrated system that stores the solar energy collected by the photovoltaic
                                                    panels</p></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <img src="images/Infynito80/fsea/main.jpg" alt="" className="clip-art w-100" />
                                </div>
                                <div className="col-lg-6 position-relative order-2 order-lg-1" data-aos="fade-up" data-aos-duration="1500">
                                    <img src="images/Infynito80/pin.svg" alt="" className="pin pin-fsea-01 pin-animation" />
                                    <img src="images/Infynito80/pin.svg" alt="" className="pin pin-fsea-02 pin-animation" />
                                    <img src="images/Infynito80/fsea/top-view.png" alt="" className="main-deck-fsea w-100" />
                                </div>
                                <div className="col-lg-6 position-relative order-1 order-lg-2">
                                    <div className="box box-fsea">
                                        <h3 className="mb-3">Green Energy: Solar Roof</h3>
                                        <p><strong>Solar panels:</strong> The solar panels convert sunlight into DC electricity to charge the batteries. Up to 26 solar panels are distributed on the roof of the hard top and the bow area, producing a total energy of 3.4 kW.</p>
                                        <p><strong>Hard Top:</strong> 20 solar panels provide a total of 2.4 kW.</p>
                                    <p><strong>Bow Area Cover:</strong>  6 solar panels provide a total of 1 kW.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}></div>
                        </div>
                    </div>

                    <div className="contaniner-fluid bkg-battery py-5">
                        <div className="container py-5">
                            <div className="row justify-content-center">
                                <div className="col-md-10 text-center pt-md-5 intro-fsea" data-aos="zoom-in">
                                    <h2 className="text-uppercase mb-3 pb-5">For when you are on the go</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card card-battery">
                                        <div className="row border-bottom mb-5 pb-5">
                                            <div className="col-md-9">
                                                <p>Energy Bank</p>
                                                <p className="big">Lithium Battery</p>
                                                <p>High energy density battery cell provides more energy with less weight. The integrated battery management system brings the highest standard in safety and provides real-time status of the battery.</p>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="valign">
                                                    <div className="align-middle d-table-cell">
                                                        <div className="d-table mx-auto text-center">
                                                            <img src="images/Infynito80/fsea/battery.png" alt="" className="w-25 w-lg-50" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row border-bottom mb-5 pb-5">
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Battery Power x 1</p>
                                                <p className="big">7.8</p>
                                                <p>kWh</p>
                                            </div>
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Total Battery Quantity</p>
                                                <p className="big">14</p>
                                                <p>pcs</p>
                                            </div>
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Total Power</p>
                                                <p className="big">109</p>
                                                <p>kWh</p>
                                            </div>
                                        </div>
                                        <div className="row pb-5">
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Inverter Charger Power x 1 (25°C)</p>
                                                <p className="big">7.8</p>
                                                <p>kWh</p>
                                            </div>
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Inverter Charger Quantity</p>
                                                <p className="big">3</p>
                                                <p>pcs</p>
                                            </div>
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Total Power</p>
                                                <p className="big">19.2</p>
                                                <p>kWh</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                <div className="contaniner-fluid bkg-battery py-5 d-none d-lg-block">
                        <div className="container py-5">
                            <div className="row justify-content-center">
                                <div className="col-md-10 text-center pt-md-5 intro-fsea" data-aos="zoom-in">
                                    <h2 className="text-uppercase mb-3 pb-5">Discover your inner tranquility</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card card-battery">
                                        <img src="images/Infynito80/fsea/battery-animation.gif" alt="" className="w-100" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="contaniner-fluid bkg-materials py-5">
                        <div className="container py-5">
                            <div className="row gy-5 justify-content-center">
                                <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                    <h2 className="text-uppercase mb-4 fsea-materials">Evolving with the <span className="leaf position-relative">planet</span> in Mind</h2>
                                    <img src="images/Infynito80/fsea/mind.jpg" alt="" className="clip-art w-100" />
                                </div>
                                <div className="col-md-8">
                                    <h2 className="big fsea-materials">Environmentally friendly materials</h2>
                                    <hr />

                                </div>
                                <div className="col-md-8" data-aos="fade-up" data-aos-duration="1500">
                                    <p className="versus-text"><strong>Recyclable Materials - Fabrics &amp; Leather</strong></p>
                                    <p>Helps to reduce the need for landfill and more costly forms of disposal, thus reducing the need for extracting (mining, quarrying, logging), refining, and processing raw materials, all of which create substantial air and water pollution.
                                    </p>
                                </div>
                                <div className="col-md-8" data-aos="fade-up" data-aos-duration="1500">
                                    <p className="versus-text"><strong>Non-toxic Paintings - Paintings</strong></p>
                                    <p>The use of paints for interiors where both the solvent component and the resinous part do not contain chemical products. Such paints prevent the production of harmful emissions, resulting in no negative side effects on the environment.</p>
                                </div>
                                <div className="col-md-8 pb-5" data-aos="fade-up" data-aos-duration="1500">
                                    <p className="versus-text"><strong>FSC 5 Certification - Lamellar Teak</strong></p>
                                    <p>The world’s most trusted sustainable forest management solution. A commitment to environmental protection, which incorporates safeguarding measures to prevent deforestation in natural forests and plantations—particularly in protected areas.</p>
                                </div>
                            </div>
                        </div>
                    </div>


                </>

            }


            {props.cultureCode === "it-it" &&
                <>
                    <div className="header-section text-white text-center py-5" id="Fsea"><h1 className="h1">FSEA</h1></div>
                    <div className="contaniner-fluid bkg-fsea pt-5" >
                        <div className="container py-5">
                            <div className="row justify-content-center">
                                <div className="col-md-10 text-center intro-fsea" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3">La luce da una nuova prospettiva</h2>
                                    <p className="text-start"> Tecnologia F.S.E.A. (Ferretti Sustainable Enhanced Architecture), un pacchetto di soluzioni per una navigazione sostenibile:</p>
                                    <div className="row justify-content-center">
                                        <div className="col-md-10">
                                            <ul className="text-start mb-5">
                                                <li><p>scafo a dislocamento veloce ottimizzato per migliorare l’efficienza nei consumi di carburante e ridurre l’impatto ambientale</p></li>
                                                <li><p>particolare attenzione all’uso di materiali green</p></li>
                                                <li><p>sistema integrato per l’accumulo dell’energia solare raccolta dai pannelli fotovoltaici</p></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <img src="images/Infynito80/fsea/main.jpg" alt="" className="clip-art w-100" />
                                </div>
                                <div className="col-lg-6 position-relative order-2 order-lg-1" data-aos="fade-up" data-aos-duration="1500">
                                    <img src="images/Infynito80/pin.svg" alt="" className="pin pin-fsea-01 pin-animation" />
                                    <img src="images/Infynito80/pin.svg" alt="" className="pin pin-fsea-02 pin-animation" />
                                    <img src="images/Infynito80/fsea/top-view.png" alt="" className="main-deck-fsea w-100" />
                                </div>
                                <div className="col-lg-6 position-relative order-1 order-lg-2">
                                    <div className="box box-fsea">
                                        <h3 className="mb-3">Energia green: Solar Roof</h3>
                                    <p><strong>Solar panels:</strong> I pannelli solari convertono la luce del sole in energia a corrente continua per caricare le batterie.
                                        Sul tetto dell'hard top e dell’area di prua possono essere installati fino a 26 pannelli solari che producono fino ad un totale di 3,4 kW di energia.
</p>
                                    <p><strong>Hard Top:</strong> 20 pannelli solari producono fino a 2,4 kw di energia.</p>
                                    <p><strong>Tetto area di prua:</strong> 6 pannelli solari producono fino a 1 kw di energia.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}></div>
                        </div>
                    </div>

                    <div className="contaniner-fluid bkg-battery py-5">
                        <div className="container py-5">
                            <div className="row justify-content-center">
                                <div className="col-md-10 text-center pt-md-5 intro-fsea" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 pb-5">Energia in movimento</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card card-battery">
                                        <div className="row border-bottom mb-5 pb-5">
                                            <div className="col-md-9">
                                                <p>Energy Bank</p>
                                                <p className="big">Batteria al Litio</p>
                                                <p>La batteria ad alta densità energetica produce più energia, pur mantenendo contenuto il peso. Il sistema di gestione integrato della batteria garantisce i più alti standard di sicurezza e fornisce informazioni sullo stato della batteria in tempo reale.</p>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="valign">
                                                    <div className="align-middle d-table-cell">
                                                        <div className="d-table mx-auto text-center">
                                                            <img src="images/Infynito80/fsea/battery.png" alt="" className="w-25 w-lg-50" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row border-bottom mb-5 pb-5">
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Potenza Batteria x 1</p>
                                                <p className="big">7,8</p>
                                                <p>kWh</p>
                                            </div>
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Quantità Batterie</p>
                                                <p className="big">14</p>
                                                <p>pcs</p>
                                            </div>
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Potenza Totale</p>
                                                <p className="big">109</p>
                                                <p>kWh</p>
                                            </div>
                                        </div>
                                        <div className="row pb-5">
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Inverter Caricabatterie Potenza x 1 @ 25℃</p>
                                                <p className="big">7,8</p>
                                                <p>kWh</p>
                                            </div>
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Quantità Inverter Caricabatterie</p>
                                                <p className="big">3</p>
                                                <p>pcs</p>
                                            </div>
                                            <div className="col-md-4 text-center text-md-start">
                                                <p className="title-battery">Potenza Totale</p>
                                                <p className="big">19,2</p>
                                                <p>kWh</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="contaniner-fluid bkg-battery py-5">
                        <div className="container py-5">
                            <div className="row justify-content-center">
                                <div className="col-md-10 text-center pt-md-5 intro-fsea" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 pb-5">Scopri la tranquillità che fa per te</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card card-battery">
                                        <img src="images/Infynito80/fsea/battery-animation-ita.gif" alt="" className="w-100" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="contaniner-fluid bkg-materials py-5">
                        <div className="container py-5">
                            <div className="row gy-5 justify-content-center">
                                <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-4 fsea-materials">L’<span className="leaf position-relative">ambiente</span> al primo posto</h2>
                                    <img src="images/Infynito80/fsea/mind.jpg" alt="" className="clip-art w-100" />
                                </div>
                                <div className="col-md-8">
                                <h2 className="big fsea-materials">Materiali sostenibili</h2>
                                    <hr />

                                </div>
                                <div className="col-md-8" data-aos="fade-up" data-aos-duration="1500">
                                    <p className="versus-text"><strong>Materiali Riciclabili - Tessuti e Pelli</strong></p>
                                    <p>Utilizzando materiali ecosostenibili si previene il ricorso a discariche e a forme di smaltimento più costose. In questo modo, si riduce quindi la necessità di estrarre (miniere, cave, disboscamenti), raffinare e lavorare le materie prime, tutte attività che creano un notevole inquinamento dell'aria e dell'acqua.</p>
                                </div>
                                <div className="col-md-8" data-aos="fade-up" data-aos-duration="1500">
                                    <p className="versus-text"><strong>Vernici Ecologiche</strong></p>
                                    <p>Tutti i cicli di verniciatura dei materiali (essenze, laccati) interni sono a base d’acqua ed ecologici: sia la componente solvente che la parte resinosa non contengono prodotti chimici. Tali vernici evitano emissioni nocive e non hanno effetti collaterali negativi sull'ambiente.</p>
                                </div>
                                <div className="col-md-8 pb-5" data-aos="fade-up" data-aos-duration="1500">
                                    <p className="versus-text"><strong>Teak Lamellare - Certificazione FSC 5</strong></p>
                                    <p>Si tratta della soluzione di Gestione Forestale sostenibile più affidabile al mondo. Un impegno per la tutela dell'ambiente, che prevede misure di salvaguardia per evitare la deforestazione delle foreste naturali e delle piantagioni, in particolar modo nelle aree protette.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }

        </>
    );

};

export default FseaSection;